import Button from "@/components/ui/button";
import { toast_configs } from "@core/constants/toast_configs";
import { show_mutation_error_toast } from "@/helpers/mutationErrors";
import { BellOff, BellRing } from "lucide-react";

const NotifyProduct = ({ add_product_to_notifications_handler, mix_variant, is_notify }) => {

    const add_to_notify = (e) =>
        add_product_to_notifications_handler(e, {
            success_callback: (data) =>
                toast_configs("عملیات با موفقیت انجام شد", "success", {
                    className: "toast-general-style",
                }),
            error_callback: show_mutation_error_toast,
        });
    return (
        <>
            <Button
                start_icon={is_notify?.[mix_variant?.keys] ? <BellOff size={20} /> : <BellRing size={20} />}
                text={is_notify?.[mix_variant?.keys] ? " دیگه لازم نیست خبرم کنید " : " موجود شد خبرم کنید "}
                onClick={(e) => add_to_notify(e)}
                color_type={is_notify?.[mix_variant?.keys] ? "secondary" : "primary"}
                className="whitespace-nowrap w-full" />
        </>
    );
}

export default NotifyProduct;